<template>
  <section
    class="powerbi-report"
    style="
      margin: 0px;
      padding: 0px;
      overflow: hidden;
      height: 100%;
      width: 100%;
      position: absolute;
      padding: 20px;
    "
  >
    <iframe
      width="100%"
      height="100%"
      style="
        overflow: hidden;
        height: 100%;
        width: 100%;
        border-radius: 4px;
        box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
      "
      :src="embeddedUrl"
      frameborder="0"
      allowFullScreen="true"
    />
  </section>
</template>

<script>
export default {
  name: "PowerBIReport",
  props: {
    reportId: String,
    autoAuth: String,
    ctid: String,
    config: String,
    filterPaneEnabled: String,
    navContentPaneEnabled: String,
  },
  computed: {
    embeddedUrl() {
      let url = `https://app.powerbi.com/reportEmbed?reportId=${this.reportId}&autoAuth=${this.autoAuth}&ctid=${this.ctid}&config=${this.config}`;

      if (this.filterPaneEnabled) {
        url = `${url}&filterPaneEnabled=${this.filterPaneEnabled}`;
      }

      if (this.navContentPaneEnabled) {
        url = `${url}&navContentPaneEnabled=${this.navContentPaneEnabled}`;
      }

      return url;
    },
  },
};
</script>
